import { render, staticRenderFns } from "./CollectionsManage.vue?vue&type=template&id=42afde32&scoped=true&"
import script from "./CollectionsManage.vue?vue&type=script&lang=js&"
export * from "./CollectionsManage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsManage.vue?vue&type=style&index=0&id=42afde32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afde32",
  null
  
)

export default component.exports